import { FC } from 'react';

import { KnzComponentProps } from '../../types';

/**
 * 設問の正解コード（言語ごと）ブロック。
 * params: file（正解コードのファイルパス・必須）/ expected（Expected の id リスト）
 *
 * これは研修設問のプレフィル用メタデータであり、記事本文としては**描画しない**（null）。
 * 反映時にフロントが knz をパースして構造化データ（file→fileId / expected→由来）を抽出する。
 * 検証定義の詳細は議題6 / D6-B、実際の検証値（arguments/stdout）は DB にコピー保持（D6-B3）。
 */
export const AnswerCode: FC<KnzComponentProps> = () => null;

export default AnswerCode;
